import { render, staticRenderFns } from "./RuleSetting.vue?vue&type=template&id=656d0a8e"
import script from "./RuleSetting.vue?vue&type=script&lang=js"
export * from "./RuleSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports